var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.logged_user.id)?_c('div',{staticStyle:{"justify-content":"center"},attrs:{"row":""}},[_c('LoginFields',{attrs:{"custom_login":false}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }